import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import type { TooltipBarGraphMultipleValue } from 'lumen/components/hotel-and-market/revenue-insight/tooltips/tooltip-bar-graph-multiple';
import HotelAndMarketRevenueInsightTooltipsTooltipBarGraphMultiple from 'lumen/components/hotel-and-market/revenue-insight/tooltips/tooltip-bar-graph-multiple';
import HotelAndMarketRevenueInsightTooltipsTooltipBarGraphWithChange from 'lumen/components/hotel-and-market/revenue-insight/tooltips/tooltip-bar-graph-with-change';
import {
  changeValueFormat,
  valueFormat,
} from 'lumen/utils/revenue-insight/value-formatting';

export interface CellTooltipBarValue {
  maxValue: number;
  value: number;
  valueClass: string | undefined;
}

interface HotelAndMarketRevenueInsightTablesCellsCellTooltipBarSignature {
  Args: {
    isChange: boolean;
    isSingleKpi: boolean;
    progressBarValues: TooltipBarGraphMultipleValue[];
    showPercentage: boolean;
    values: CellTooltipBarValue[];
  };
  Element: HTMLDivElement;
}

export default class HotelAndMarketRevenueInsightTablesCellsCellTooltipBar extends Component<HotelAndMarketRevenueInsightTablesCellsCellTooltipBarSignature> {
  @service declare intl: Services['intl'];

  get firstValueMaxValue(): number | undefined {
    return this.args.values[0]?.maxValue;
  }

  get firstValueValue(): number | undefined {
    return this.args.values[0]?.value;
  }

  <template>
    <td class={{if @isSingleKpi "no-border"}}>
      <div class="tooltip-bar-container flex flex-row">
        <div class="tooltip-bar">
          {{#if @isChange}}
            <HotelAndMarketRevenueInsightTooltipsTooltipBarGraphWithChange
              @maxValue={{this.firstValueMaxValue}}
              @value={{this.firstValueValue}}
            />
          {{else}}
            <HotelAndMarketRevenueInsightTooltipsTooltipBarGraphMultiple
              @values={{@progressBarValues}}
            />
          {{/if}}
        </div>
        <div class="flex flex-col">
          {{#each @values as |cellTooltipBarValue|}}
            <div
              class="tooltip-bar-value text-end
                {{cellTooltipBarValue.valueClass}}"
              ...attributes
            >
              {{#if @isChange}}
                {{changeValueFormat
                  cellTooltipBarValue.value
                  @showPercentage
                  this.intl
                }}
              {{else}}
                {{valueFormat
                  cellTooltipBarValue.value
                  @showPercentage
                  this.intl
                }}
              {{/if}}
            </div>
          {{/each}}
        </div>
      </div>
    </td>
  </template>
}
